export enum EnvironmentNames {
  Development = 'Development',
  'Quality Assurance' = 'Quality Assurance',
  Production = 'Production',
  'Integration Test' = 'Integration Test',
  'Unit Test' = 'Unit Test',
  Local = 'Local',
  Unknown = 'Unknown',
}

export interface Environment {
  name: string;
  envName: keyof typeof EnvironmentNames;
  showEnv?: boolean;
  hmr: boolean;
  isProduction: boolean;
  auth: {
    enabled: boolean;
    clientId: string;
  };
  build: {
    tag: string;
    branchName: string;
    buildNumber: string;
  };
  appInsights: {
    connectionString: string;
  };
  backend: {
    url: string;
  };
  support: {
    mail: {
      to: string;
      cc?: string;
    };
  };
}

export function parseEnvName(envName: string): EnvironmentNames {
  return Object.keys(EnvironmentNames).includes(envName) ? (envName as EnvironmentNames) : EnvironmentNames.Unknown;
}
